import { useAppQuery } from "~/hooks/useAppQuery"
import { getCurrentUser } from "../server/profile.functions"

export const profileUserQueryKey = ["home", "profile", "user"] satisfies readonly ["home", "profile", "user"]

export function useUser() {
  return useAppQuery({
    queryKey: profileUserQueryKey,
    queryFn: () => getCurrentUser(),
    errorMessage: "Не удалось загрузить профиль",
  })
}
